import React, { Component, Fragment } from "react";
import findCustomers from "../services/customersService";
import DefaultPopup from "./common/defaultPopup";
import Select from "./common/select";

class CustomerWithContactForm extends Component {
    constructor(props) {
        super(props);
        this.isEditable = props.isEditable;
        this.state = {
            searchResults: [],
            openSearchPopup: false,
            openCustomerContactPopup: false
        };

        this.customerIdInput = React.createRef();
        this.customerSearchInput = React.createRef();
        this.contactIdInput = React.createRef();
        this.selectedItem = null;
    }

    handleOpenSearchPopup = () => {
        this.setState({
            openSearchPopup: true
        });
    };

    handleOpenedSearchPopup = async () => {

        if (this.customerSearchInput.current) {
            this.customerSearchInput.current.focus();
            document.onkeydown = this.checkKey;
        } else {
            // For some reason this is needed on production server since the above occurs to early
            setTimeout(() => {
                try {
                    this.customerSearchInput.current.focus();
                    document.onkeydown = this.checkKey;
                } catch (e) { }
            }, 500);
        }

        let searchResults = [];

        this.setState({
            searchResults
        });
    };


    navigateResultList = (nextRow) => {

        if (nextRow != null) {
            this.selectedItem.focus();
            this.selectedItem.classList.remove('selected');

            nextRow.focus();
            nextRow.classList.add('selected');
            this.selectedItem = nextRow;
        }
    }

    checkKey = (e) => {
        e = e || window.event;

        if (e.keyCode == 38 || (event.shiftKey && event.keyCode == 9)) {
            // Up arrow and tab
            if (this.selectedItem == null) return;

            let nextrow = this.selectedItem.previousElementSibling;
            if (nextrow != null && nextrow.classList.contains('resultItem')) {
                this.navigateResultList(nextrow);
            }
        } else if (e.keyCode == 40 || (!event.shiftKey && event.keyCode == 9)) {
            // Down arrow and shift tab
            if (this.selectedItem == null) {

                const resultItems = document.getElementsByClassName('resultItem');
                if (resultItems.length == 0) return;

                this.selectedItem = resultItems[0];
                this.navigateResultList(this.selectedItem);
                return;
            }

            let nextrow = this.selectedItem.nextElementSibling;

            if (nextrow != null) {
                this.navigateResultList(nextrow);
            }
        } else if (e.keyCode == 13) {
            this.selectedItem.querySelector('a').click();
        }
    }

    handleCustomerSearch = async () => {
        const name = this.customerSearchInput.current.value;
        const searchParams = {
            name
        };

        let searchResults = [];
        try {
            const response = await findCustomers(searchParams);
            searchResults = response.data;
        } catch (e) { }

        this.setState({
            searchResults
        });
    };

    handleCustomerSelect = customer => {
        if ("function" === typeof this.props.onCustomerSelect) {
            this.props.onCustomerSelect(customer);
        }

        this.setState({
            openSearchPopup: false
        });
    };

    handleClosedSearchPopup = () => {
        this.setState({
            openSearchPopup: false
        });
        document.onkeydown = null;
    };

    handleOpenCustomerContactPopup = () => {
        const { contact } = this.props;

        this.setState({
            openCustomerContactPopup: contact != null
        });
    };

    handleOpenedCustomerContactPopup = async () => { };

    handleClosedCustomerContactPopup = () => {
        this.setState({
            openCustomerContactPopup: false
        });
    };

    renderContact() {
        const { contact, contacts, onContactSelect } = this.props;

        if (this.isEditable) {
            return (
                <div className="customerWithContactForm">
                    <Fragment>
                        <Select
                            name="customer_contact_id"
                            label="Kontaktperson"
                            onChange={event => {
                                const val = event.target.value;
                                const index = contacts.findIndex(
                                    item => item._id == val
                                );

                                if (index >= 0) {
                                    const selectedContact = contacts[index];
                                    onContactSelect(selectedContact);
                                }
                            }}
                            options={contacts}
                            value={contact != null ? contact.id : ""}
                            className="flex-grow-1"
                        />
                        <div className="form-group">
                            <div>
                                <label>&nbsp;</label>
                            </div>
                            <a
                                onClick={this.handleOpenCustomerContactPopup}
                                className="btn btn-icon btn-icon--person btn-icon--noText"
                                role="button"
                                tabIndex="0"
                            />
                        </div>
                    </Fragment>
                </div>
            );
        } else {
            return (
                <Fragment>
                    <label>Kontaktperson</label>
                    <div className="form-control position-relative">
                        {contact != null
                            ? contact.firstname + " " + contact.lastname
                            : ""}
                        <a
                            onClick={this.handleOpenCustomerContactPopup}
                            className="btn btn-appendToTheRightOfField btn-icon btn-icon--person btn-icon--noText"
                            role="button"
                            tabIndex="0"
                        />
                    </div>
                </Fragment>
            );
        }
    }

    render() {
        const {
            customer,
            contact,
            error,
            costEstimateId,
            editingCopy
        } = this.props;
        const {
            openSearchPopup,
            openCustomerContactPopup,
            searchResults
        } = this.state;

        this.selectedItem = null;

        return (
            <Fragment>
                <div className="col-sm-2 col-lg-1">
                    <div className="form-group">
                        <label>Kundnr.</label>
                        {this.isEditable && (
                            <Fragment>
                                <input
                                    ref={this.customerIdTextInput}
                                    name="customer_number"
                                    value={
                                        customer && customer.customer_number
                                            ? customer.customer_number
                                            : ""
                                    }
                                    className="form-control"
                                    readOnly
                                    required
                                />
                                <input
                                    type="hidden"
                                    name="customer_id"
                                    value={
                                        customer && customer.id
                                            ? customer.id
                                            : ""
                                    }
                                />
                            </Fragment>
                        )}
                        {!this.isEditable && (
                            <div className="form-control">
                                {customer && customer.customer_number}
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-sm-3 pl-0">
                    <div className="form-group">
                        <label>Kund</label>
                        <div
                            className={
                                "form-control position-relative" +
                                (error ? " is-invalid" : "")
                            }
                        >
                            {customer && (<a href={"/customers/" + customer.id} style={{ color: 'inherit' }}>{customer.name}</a>)}
                            {this.isEditable &&
                                (!costEstimateId || editingCopy) && (
                                    <a
                                        onClick={this.handleOpenSearchPopup}
                                        className="btn btn-appendToTheRightOfField btn-icon btn-icon--person btn-icon--noText"
                                        role="button"
                                        tabIndex="0"
                                    />
                                )}
                        </div>
                        <span className="invalid-feedback" role="alert">
                            {error && error.message}
                        </span>
                    </div>
                </div>
                <div className="col-sm-3 col-lg-2 pl-0">
                    {this.renderContact()}
                </div>
                <DefaultPopup
                    onClosePopup={this.handleClosedSearchPopup}
                    onOpenPopup={this.handleOpenedSearchPopup}
                    openPopup={openSearchPopup}
                    title="Sök bland kunder"
                    contentClassName="content"
                >
                    <Fragment>
                        <div className="row mt-3">
                            <div className="col-sm-8 col-xl-6">
                                <div className="form-group">
                                    <input
                                        autoComplete="off"
                                        className="form-control"
                                        onChange={() =>
                                            this.handleCustomerSearch()
                                        }
                                        placeholder="Ange kundnamn"
                                        ref={this.customerSearchInput}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                {searchResults.length > 0 && (
                                    <Fragment>
                                        <div className="stripedRows customerResultList">
                                            <div className="row">
                                                <div className="col-4">
                                                    <strong>Kund</strong>
                                                </div>
                                                <div className="col-4">
                                                    <strong>Adress</strong>
                                                </div>
                                                <div className="col-4">
                                                    <strong>Stad</strong>
                                                </div>
                                            </div>
                                            {searchResults.map((customer, index) => (
                                                <div
                                                    className="row pt-2 pb-2 resultItem"
                                                    key={customer.id}
                                                >
                                                    <div className="col-4">
                                                        <a
                                                            onClick={() =>
                                                                this.handleCustomerSelect(
                                                                    customer
                                                                )
                                                            }
                                                            role="button"
                                                            tabIndex="0"
                                                        >
                                                            {customer.name}
                                                        </a>
                                                    </div>
                                                    <div className="col-4">
                                                        {customer.address1}
                                                    </div>
                                                    <div className="col-4">
                                                        {customer.city}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </Fragment>
                                )}
                            </div>
                        </div>
                    </Fragment>
                </DefaultPopup>
                <DefaultPopup
                    onClosePopup={this.handleClosedCustomerContactPopup}
                    onOpenPopup={this.handleOpenedCustomerContactPopup}
                    openPopup={contact ? openCustomerContactPopup : null}
                    title={
                        contact
                            ? contact.firstname + " " + contact.lastname
                            : ""
                    }
                    contentClassName="darkBackground"
                >
                    <Fragment>
                        <div className="row">
                            <div className="col">
                                <div className="responsiveIframe">
                                    <iframe
                                        className=""
                                        height="400"
                                        src={
                                            contact
                                                ? "/customer-contacts/reactShow/" +
                                                contact.id
                                                : ""
                                        }
                                        frameBorder="0"
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    </Fragment>
                </DefaultPopup>
            </Fragment>
        );
    }
}

export default CustomerWithContactForm;
